"use client";

import { useTranslations } from "next-intl";
import { useCheckoutStore } from "@/lib/store/checkout";
import { ExpandingArrowRight } from "../expanding-arrow-right";

export const UseShippingCard = () => {
  const t = useTranslations("address");
  const shippingAddress = useCheckoutStore((s) => s.shippingAddress);
  const setBilling = useCheckoutStore((s) => s.setBilling);
  const completeCurrentStep = useCheckoutStore((s) => s.completeCurrentStep);

  if (!shippingAddress) return null;

  const onClick = () => {
    if (!shippingAddress) return;
    setBilling(shippingAddress);
    completeCurrentStep();
  };

  const formatted = [
    shippingAddress.addressLine1,
    shippingAddress.addressLine2,
    shippingAddress.city,
    shippingAddress.state,
    shippingAddress.zipCode,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <button
      type="button"
      className="group flex cursor-pointer flex-row items-center rounded-lg border border-border bg-background p-2 text-start hover:bg-top"
      onClick={onClick}
    >
      <div className="flex-1">
        <p className="font-medium text-sm">{t("useShippingAddress")}</p>
        <p className="text-muted text-sm">{formatted}</p>
      </div>
      <div className="shrink-0">
        <ExpandingArrowRight />
      </div>
    </button>
  );
};
